import React from 'react';
import { Wrench } from 'lucide-react'; // Importing the Wrench icon

// Define the core colors as constants for reuse and clarity
const PRIMARY_COLOR_HEX = '#7E57C2'; // Deep Purple
const LIGHT_PURPLE = '#9575CD'; // Lighter Purple for shimmer contrast

// Inject custom keyframes for the shimmering progress bar
const customStyles = `
@keyframes shimmer {
  0% { background-position: 0% 0; }
  100% { background-position: 100% 0; }
}
.animate-shimmer {
  background-size: 150px 100%; /* Size of the stripes */
  animation: shimmer 1s linear infinite;
}
`;

// Main Under Construction UnderConstruction Component
const UnderConstruction: React.FC = () => {

  // Barricade pattern style using a repeating linear gradient
  const barricadeStyle = {
    backgroundImage: `repeating-linear-gradient(
      45deg,
      white,
      white 20px,
      ${PRIMARY_COLOR_HEX} 20px,
      ${PRIMARY_COLOR_HEX} 40px
    )`,
    border: `8px solid ${PRIMARY_COLOR_HEX}`
  };

  // Progress Bar Gradient
  const progressBarGradient = {
    backgroundImage: `repeating-linear-gradient(
      90deg,
      ${PRIMARY_COLOR_HEX},
      ${PRIMARY_COLOR_HEX} 25px,
      ${LIGHT_PURPLE} 25px,
      ${LIGHT_PURPLE} 50px
    )`,
  };

  return (
    <>
      {/* Injecting custom styles for the shimmer animation */}
      <style>{customStyles}</style>

      <div className="flex items-center justify-center p-4 font-inter">
        <div
          className={`w-full max-w-sm p-8 md:p-10 rounded-2xl shadow-2xl flex flex-col items-center text-center transition-all duration-300 ease-in-out`}
          style={{ backgroundColor: 'white', border: `8px solid ${PRIMARY_COLOR_HEX}` }}
        >
          
          {/* Barricade Pattern with Central Icon (Static) */}
          <div 
            className="relative mb-8 w-48 h-48 rounded-full flex items-center justify-center overflow-hidden shadow-lg"
            style={barricadeStyle}
          >
            {/* Central Icon - using Lucide's Wrench */}
            <div 
              className="p-2 rounded-xl"
              style={{ backgroundColor: PRIMARY_COLOR_HEX }}
            >
              <Wrench size={80} color="white" strokeWidth={1.5} />
            </div>
          </div>

          <h1
            className={`text-5xl md:text-6xl font-black mb-2 text-gray-900`}
          >
            Wait Up!
          </h1>
          <p
            className="text-2xl mb-8 font-extrabold tracking-tight"
            style={{ color: PRIMARY_COLOR_HEX }}
          >
            This part is under construction.
          </p>

          {/* Animated Progress Bar (Shimmer Effect) */}
          <div 
            className="w-full h-3 mb-8 rounded-full overflow-hidden shadow-inner animate-shimmer"
            style={progressBarGradient}
          >
            {/* The animation is applied directly to this single div's background */}
          </div>


          <p className="text-gray-600 text-base md:text-lg max-w-xs">
            Our team is making some fun improvements. We'll be back online and ready to shine shortly! ✨
          </p>
        </div>
      </div>
    </>
  );
};

export default UnderConstruction;